import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { HttpStatusError } from "@/api/classifier";
import { addToGoldenDataset } from "@/api/reviews";
import { goldenDatasetStatusQueryKey } from "./goldenDatasetStatusQueryKey";

const CONFLICT_STATUS = 409;

export function useAddToGoldenDataset({ onCodesChanged }: { onCodesChanged?: () => void } = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addToGoldenDataset,
    onSuccess: ({ datasetId, outcome }, { encounterId }) => {
      toast.success(outcome === "created" ? `Added to ${datasetId}` : `Updated ${datasetId}`);
      return queryClient.invalidateQueries({ queryKey: goldenDatasetStatusQueryKey(encounterId) });
    },
    onError: (error: Error) => {
      toast.error(error.message);
      if (error instanceof HttpStatusError && error.status === CONFLICT_STATUS) {
        onCodesChanged?.();
      }
    },
  });
}
